import { useEffect } from 'react';

/**
 * AOS (used via data-aos attributes throughout the app) only scans the DOM
 * once at init. In this SPA, most sections mount later via React.lazy/Suspense
 * (route chunks, and nested Suspense inside Home), after AOS's initial scan
 * has already run — so their fade-up animations would silently never fire.
 * This re-scans (refreshHard) whenever the DOM changes, debounced, so
 * lazily-mounted content still gets registered.
 */
export function useAos() {
    useEffect(() => {
        if (!window.AOS) return undefined;

        window.AOS.init({ duration: 600, easing: 'ease-in-out', once: true, mirror: false });

        let timeoutId;
        const observer = new MutationObserver(() => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => window.AOS.refreshHard(), 150);
        });
        observer.observe(document.body, { childList: true, subtree: true });

        return () => {
            clearTimeout(timeoutId);
            observer.disconnect();
        };
    }, []);
}
